module.exports = __webpack_public_path__ + "static/img/6.0ed63e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/6.png
// module id = QFQK
// module chunks = 1